var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container mt-4"},[_c('h1',[_vm._v("Not Found")]),_c('p',{attrs:{"className":"lead"}},[_vm._v("The page you are looking for does not exist")]),_c('router-link',{staticClass:"btn btn-light",attrs:{"to":"/"}},[_vm._v(" Back To Search ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }